module.exports = __webpack_public_path__ + "media/images/fonts/Feather-eb9822a3be07c5110df9f311356c7f33.woff";